<template>
    <div class="h-100">

        <div class="d-flex py-2">
            <div class="ms-2 mt-1">Page Editor</div>

            <div class="m-1">
                | <strong>{{componentTitle}}</strong>
            </div>

            <div class="mx-2">
                <a v-if="pageId" href="javascript:void(0)" @click="onPreviewClick" class="btn btn-sm btn-primary mx-2" >preview site</a>
            </div>

            <div class="mx-2">
                <button class="btn btn-light btn-sm" @click="onNewPageClick" data-bs-toggle="tooltip" data-placement="top" data-bs-title="new page">
                    <i class="fas fa-plus text-primary"></i>
                </button>

                <button class="btn btn-light btn-sm" @click="pageToEdit = page; showPageEditorModal = true" data-bs-toggle="tooltip" data-placement="top" data-bs-title="edit page">
                    <i class="fas fa-pencil text-primary"></i>
                </button>

                <button class="btn btn-light btn-sm" @click="onCopyPageClick" data-bs-toggle="tooltip" data-placement="top" data-bs-title="copy page">
                    <i class="fas fa-copy text-primary"></i>
                </button>

                <button class="btn btn-light btn-sm" @click="onDeletePageClick" data-bs-toggle="tooltip" data-placement="top" data-bs-title="delete page">
                    <i class="fas fa-trash-alt text-primary"></i>
                </button>
            </div>

            <div v-if="model.app.id" class="mx-2">
<!--                <theme-dropdown :current-app="model.app"></theme-dropdown>-->

                <button class="btn btn-light btn-sm" @click="showThemeBrowserModal = true">
                    Themes
                </button>

            </div>

            <div class="me-auto">
                <div id="pageEditorDropdown" class="dropdown">
                    <button class="btn btn-light btn-sm dropdown-toggle" type="button" id="pageOptionsDropdown"
                            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fas fa-ellipsis-h"></i>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="pageOptionsDropdown">

                        <h6 class="dropdown-header">Pages</h6>
                        <router-link v-for="page in model.website.webpages" :key="page.slug"
                                     :to="{ name: 'page-editor', params: {pageId: page.slug}}"
                                     class="dropdown-item">
                            {{page.title}}
                        </router-link>

                        <div v-if="isPublishAuthorized" class="dropdown-divider"></div>
                        <a v-if="isPublishAuthorized" class="dropdown-item" href="javascript:void(0)" @click.stop="onPublishClick()">Publish to Custom Domain</a>

                        <div class="dropdown-divider"></div>
                        <h6 class="dropdown-header">Site Components</h6>
                        <router-link v-if="model.website.slug" key="siteHeader"
                                     :to="{ name: 'layout-editor', params: {siteId: model.website.slug, layoutType: 'header'}}"
                                     class="dropdown-item">
                            Nav Bar
                        </router-link>
                        <router-link v-if="model.website.slug" key="siteFooter"
                                     :to="{ name: 'layout-editor', params: {siteId: model.website.slug, layoutType: 'footer'}}"
                                     class="dropdown-item">
                            Footer
                        </router-link>

                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="javascript:void(0)" @click.stop="onEditSiteClick()">Edit site</a>
<!--                        <a class="dropdown-item" href="javascript:void(0)" @click.stop="showFontModal = true">Edit fonts</a>-->
<!--                        <a class="dropdown-item" href="javascript:void(0)" @click.stop="showThemeBrowserModal = true">Browse themes</a>-->
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" :href="createTemplateUrl" target="_blank">Create Template from Site</a>

                    </div>
                </div>
            </div>

            <div class="mx-2">
                <a href="javascript:void(0)" @click="onPublishSiteClick" class="btn btn-sm btn-danger mx-2">publish site</a>
            </div>

            <!-- used for spacing -->
            <div class="col-2"></div>
        </div>

        <div class="row mx-0" v-if="layout">
            <div class="col-2 bg-light left-sidebar">
                <element-selector :layout="layout" :layout-type="layoutType"></element-selector>
            </div>

            <div class="col-8 center-container mb-5 text-font" :style="siteStyle">
<!--                <nav-renderer v-if="layoutType === 'header'" :layout="layout"></nav-renderer>-->
                <nav-renderer-plus v-if="layoutType === 'header'" :layout="layout"></nav-renderer-plus>
                <layout-renderer v-else :layout="layout" :page="page"></layout-renderer>
            </div>

            <div class="col-2 bg-light right-sidebar px-0">
                <page-property-editor :layout="layout" :page="page" :layout-type="layoutType"></page-property-editor>
            </div>
        </div>

        <confirm-modal
                v-if="showConfirmModal"
                @noEvent="showConfirmModal = false"
                :yesEvent="deleteResource"
                :text="'Are you sure you want to delete this ' + resourceToDelete + '?  This cannot be undone.'">
        </confirm-modal>

        <emoji-modal v-if="showEmojiModal" @noEvent="showEmojiModal = false" :selected-component="layout.selectedComponent"></emoji-modal>

        <image-modal v-if="showImageModal" @noEvent="showImageModal = false" :page="page" key="bgPageImageModal"
                     :website="model.website" :yes-event="imageSelected"></image-modal>

        <icon-modal v-if="showIconModal" @noEvent="showIconModal = false" :yesEvent="iconSelected"></icon-modal>

        <website-form-modal v-if="showNewWebsiteModal" @noEvent="showNewWebsiteModal = false" :yes-event="onWebsiteSaved"
                            @deleteClick="onDeleteSiteClick" :key="model.website.slug"></website-form-modal>

<!--        <publish-form-modal v-if="showPublishModal" @noEvent="showPublishModal = false" :yes-event="onWebsiteSaved"-->
<!--                            :key="model.website.slug + 'Publish'"></publish-form-modal>-->

        <publish-wizard-modal v-if="showPublishModal" @noEvent="showPublishModal = false" :yes-event="onPublishClick"
                              :key="model.website.slug + 'Publish'" :page-id="page.slug"></publish-wizard-modal>

        <background-editor-modal v-if="showBgEditorModal" @noEvent="showBgEditorModal = false" :background="layout.selectedRow.background"></background-editor-modal>

        <animation-modal v-if="showAnimationModal" @noEvent="showAnimationModal = false" :component="layout.selectedComponent"></animation-modal>

        <page-modal v-if="showPageEditorModal" @noEvent="showPageEditorModal = false" :yes-event="onPageCreated" :page="pageToEdit"></page-modal>

        <font-modal v-if="showFontModal" @noEvent="showFontModal = false" :website="model.website"></font-modal>

        <theme-browser-modal v-if="showThemeBrowserModal" @noEvent="showThemeBrowserModal = false" :layout="layout"></theme-browser-modal>
    </div>
</template>

<script>

    import PageService from "../../services/PageService";
    import PageFactory from "../../utils/PageFactory";
    import ElementSelector from "./ElementSelector.vue";
    import LayoutRenderer from "../view/LayoutRenderer.vue";
    import PagePropertyEditor from "./PagePropertyEditor.vue";
    import ResourcesService from "../../services/ResourcesService";
    import SiteService from "../../services/SiteService";
    import ConfirmModal from "../../components/ConfirmModal.vue";
    import ImageModal from "./ImageModal.vue";
    import WebsiteFormModal from "../app/WebsiteFormModal.vue";
    import BackgroundEditorModal from "./BackgroundEditorModal.vue";
    import EmojiModal from "../../components/EmojiModal.vue";
    import AnimationModal from "../../components/AnimationModal.vue";
    import PageModal from "./PageModal.vue";
    import NavRenderer from "./NavRenderer.vue";
    import FontModal from "../../components/FontModal.vue";
    import IconModal from "./IconModal.vue";
    import StateManager from "../state/StateManager";
    import PublishFormModal from "./PublishFormModal.vue";
    import PublishWizardModal from "./PublishWizardModal.vue";
    import ThemeBrowserModal from "../../theme/ThemeBrowserModal.vue";
    import ThemeDropdown from "./ThemeDropdown.vue";
    import ThemeLoader from "../../utils/ThemeLoader";
    import NavRendererPlus from "./NavRendererPlus.vue";

    export default {
        name: 'PageEditor',
        components: {
            NavRendererPlus,
            ThemeDropdown,
            ThemeBrowserModal,
            PublishWizardModal,
            PublishFormModal,
            IconModal,
            FontModal,
            NavRenderer,
            PageModal,
            AnimationModal,
            EmojiModal,
            BackgroundEditorModal,
            WebsiteFormModal, ImageModal, ConfirmModal, PagePropertyEditor, LayoutRenderer, ElementSelector},
        props: ['pageId', 'siteId', 'layoutType'],
        computed: {
            siteStyle() {
                // override fonts if we use a theme to manage the text font
                if(this.layout.theme_id) {
                    return {}
                }

                if(this.model.website === undefined) {
                    return {
                        fontFamily: 'Raleway'
                    }
                }

                let textFont = this.model.website.metadata.textFont ? this.model.website.metadata.textFont : 'Raleway'

                if(textFont !== 'Raleway') {
                    webase.utils.ui.injectFont(textFont)
                }

                return {
                    fontFamily: textFont
                }
            },
            componentTitle() {
                return this.layoutType ? this.layoutType : this.page.title
            },
            createTemplateUrl() {
                // Everything is an app now
                return '/marketplace/new?app_id=' + this.model.website.app_id
                // return '/website-templates/new?site_id=' + this.model.website.slug
            },
            isPublishAuthorized() {
                return this.isNetlifyConfigured || (webase.utils.user.isCustomer() && this.model.website.metadata.netlifySiteId)
            },
            isNetlifyConfigured() {

                if( this.hasNetlifyIntegration && this.model.website.metadata.netlifySiteId) {
                    return true
                }

                return false
            },
            hasNetlifyIntegration() {
                return this.model.app && webase.managers.app && webase.managers.app.hasIntegration('Netlify')
            }
        },
        data() {
            return {
                model: webase.model,
                service: new PageService(),
                siteService: new SiteService(),
                page: {
                    id: null,
                    title: '',
                    slug: '',
                    show_nav: true,
                    show_footer: true,
                    home_page: false
                },
                layout: null,
                selectedRow: null,
                selectedColumn: null,
                iconSearch: '',
                pageFactory: new PageFactory(),
                showConfirmModal: false,
                deleteResource: function () {
                },
                resourceToDelete: '',
                showImageModal: false,
                imageSelected: function (image) {
                },
                showIconModal: false,
                iconSelected: function (icon) {
                },
                showEmojiModal: false,
                showNewWebsiteModal: false,
                showPublishModal: false,
                onWebsiteSaved: function (website) {
                },
                onPageCreated: function (page) {
                },
                showBgEditorModal: false,
                timerId: null,
                showAnimationModal: false,
                showPageEditorModal: false,
                showFontModal: false,
                pageToEdit: null,
                showThemeBrowserModal: false,
            }
        },
        mounted() {
            window.scrollTo(0, 0)
            webase.managers.state = new StateManager()

            if (this.pageId) {
                this.loadPage()
            } else if (this.siteId) {
                this.loadSite()
            }

            let resourcesService = new ResourcesService()
            resourcesService.getIcons()
            webase.eventDispatcher.on('updateBackgroundClick', this.onSetBackgroundClick)
            webase.eventDispatcher.on('editBackgroundPatternClick', this.onEditBackgroundPatternClick)
            webase.eventDispatcher.on('editAnimationClick', this.onEditAnimationClick)
            webase.eventDispatcher.on('editIconClick', this.onEditIconClick)
            webase.eventDispatcher.on('addEmojiClick', this.onAddEmojiClick)
            this.timerId = setInterval(this.onSaveClick, 15000);

            ThemeLoader.loadThemes()

            const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
            const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
        },
        beforeUnmount() {
            webase.eventDispatcher.off('updateBackgroundClick', this.onSetBackgroundClick)
            webase.eventDispatcher.off('editBackgroundPatternClick', this.onEditBackgroundPatternClick)
            webase.eventDispatcher.off('editAnimationClick', this.onEditAnimationClick)
            webase.eventDispatcher.off('editIconClick', this.onEditIconClick)
            webase.eventDispatcher.off('addEmojiClick', this.onAddEmojiClick)

            if(this.timerId) {
                clearInterval(this.timerId)
            }

            this.timerId = null
            this.onSaveClick()
            this.clearSelections()
        },
        methods: {
            loadPage() {
                console.log('loadPage')
                this.service.get(this.pageId).then((response) => {
                    this.initPage(response)

                    if (this.model.website.app_id) {
                        console.log('loading app')
                        webase.utils.app.loadApp(this.model.website.app_id)
                    }

                    let params = new URLSearchParams(window.location.search)

                    if(params.has('publish')) {
                        this.showPublishModal = true
                    }

                }).catch((message) => {
                    console.log('error loading view')
                    console.log(message)
                })
            },
            loadSite() {
                this.siteService.get(this.siteId).then((website) => {
                    this.model.website = website

                    if (website[this.layoutType] && website[this.layoutType].rows) {
                        this.layout = website[this.layoutType]
                        this.clearSelections()  // deselect everything
                    } else {
                        this.createHeaderOrFooter()
                    }

                    // this.createHeaderOrFooter()

                }).catch((error) => {
                    console.log('Error loading website.')
                    console.log(error)
                })
            },
            initPage(page) {
                if(page.layout.description === undefined) {
                    page.layout.description = ''
                }

                this.page = page
                this.model.website = page.website
                this.page.layout.theme_id = page.website.theme_id

                if(page.website.theme_id) {
                    new ThemeLoader(page.website.theme_id).loadTheme()
                }

                if (this.page.layout.rows) {
                    this.layout = this.page.layout
                    this.clearSelections()  // deselect everything
                } else {
                    let description = page.layout.description
                    this.loadDefaultLayout(description)
                    // this.layout.description = description
                }
            },
            clearSelections() {
                webase.utils.layout.deselectAll(this.layout)
                this.layout.selectedComponent = null
                this.layout.selectedColumn = null
                this.layout.selectedRow = null
            },
            onSaveClick() {
                if (this.pageId) {
                    this.savePage()
                } else if (this.siteId) {
                    this.saveSiteComponent()
                }
            },
            onPreviewClick() {
                if (this.pageId) {
                    let request = {
                        page: {
                            layout: this.layout
                        }
                    }

                    this.service.update(this.page.slug, request).then((response) => {
                        window.open('/sites/' + this.model.website.slug);
                    })
                }
            },
            savePage() {
                let request = {
                    page: {
                        layout: this.layout,
                        show_nav: this.page.show_nav,
                        show_footer: this.page.show_footer,
                        home_page: this.page.home_page,
                    }
                }

                this.service.update(this.page.slug, request).catch((message) => {
                    console.log('error updating page')
                    console.log(message)
                })
            },
            saveSiteComponent() {
                let request = {
                    website: {}
                }

                request.website[this.layoutType] = this.layout

                this.siteService.update(this.model.website.slug, request).catch((message) => {
                    console.log('error updating header or footer')
                    console.log(message)
                })
            },
            loadDefaultLayout(pageDescription) {
                let resourcesService = new ResourcesService()
                let url = webase.utils.app.getBaseUrl() + '/resources/default-page.json?t=' + Date.now()
                resourcesService.get(url).then( (response) => {
                    this.layout = response

                    if(pageDescription) {
                        this.layout.description = pageDescription
                    }
                })
            },
            createHeaderOrFooter() {

                if(this.layoutType === 'header') {
                    this.layout = this.pageFactory.createNavbarLayout(this.model.website)
                    return
                }

                this.layout = this.pageFactory.createReusableSiteLayout(this.layoutType)
            },
            onPublishClick() {
                this.savePage()

                this.model.loading = true
                this.siteService.deploySite(this.model.website.id).then((deployment) => {
                    this.model.loading = false

                    if(deployment['code'] === 404) {
                        let metadata = this.model.website.metadata
                        delete metadata.netlifySiteId
                    }
                    else {
                        webase.utils.notification.success('Netlify site published')
                        let siteUrl = webase.utils.integration.getNetlifySiteUrl(deployment, this.model.website)
                        window.open(siteUrl)
                    }


                }).catch((error) => {
                    console.log('Error deploying website.')
                    console.log(error)
                    this.model.loading = false
                })
            },
            onNewPageClick() {
              this.showPageEditModal('', { description: ''})
            },

            onCopyPageClick() {
              let title = 'Copy of ' + this.page.title
              let layout = JSON.parse(JSON.stringify(this.layout))
              this.showPageEditModal(title, layout)
            },

            showPageEditModal(title, layout) {
              this.pageToEdit = {
                title: title,
                layout: layout
              }

              this.showPageEditorModal = true
              this.onPageCreated = (webpage) => {
                // route back to this view with the new slug
                this.$router.push({ name: 'page-editor', params: {pageId: webpage.slug}})
              }
            },
            onDeleteSiteClick() {
                this.resourceToDelete = 'website'
                this.showConfirmModal = true

                this.deleteResource = () => {

                    this.siteService.remove(this.model.website.id).then(() => {
                        webase.utils.array.remove(this.model.websites, this.model.website.id)
                        this.showConfirmModal = false
                        this.$router.push({name: 'apps'})
                    }).catch((error) => {
                        console.log('Error removing website.')
                        console.log(error)
                        this.showConfirmModal = false
                    })
                }
            },

            onDeletePageClick() {
                this.resourceToDelete = 'page'
                this.showConfirmModal = true

                this.deleteResource = () => {

                    this.service.remove(this.pageId).then(() => {
                        let firstPage = this.getFirstPage(this.page.slug)
                        this.$router.push({ name: 'page-editor', params: {pageId: firstPage.slug}})
                        this.showConfirmModal = false
                    }).catch((message) => {
                        console.log('error deleting page')
                        console.log(message)
                        this.showConfirmModal = false
                    })
                }
            },

            onSetBackgroundClick() {
                this.showImageModal = true

                this.imageSelected = (image) => {

                    if(this.layout.selectedRow) {
                        this.layout.selectedRow.background.image = image
                    }
                }
            },

            onAddEmojiClick() {
                console.log('showEmojiModal')
                this.showEmojiModal = true
            },

            onEditBackgroundPatternClick() {
                this.showBgEditorModal = true
            },

            onEditAnimationClick() {
                this.showAnimationModal = true
            },

            onEditIconClick() {
                this.showIconModal = true
                this.iconSelected = (icon) => {
                    this.layout.selectedComponent.value = icon
                }
            },

            onEditSiteClick() {
                this.showNewWebsiteModal = true
                this.onWebsiteSaved = (website) => {
                    this.model.website = website
                }
            },

            onPublishSiteClick() {
                this.showPublishModal = true
                // if(this.isPublishAuthorized) {
                //     this.onPublishClick()
                // }
                // else {
                //     this.showPublishModal = true
                // }
            },

            getFirstPage(deletedPageId) {
                for (let i = 0; i < this.model.website.webpages.length; i++) {

                    let page = this.model.website.webpages[i]

                    if(page.slug !== deletedPageId) {
                        return page
                    }
                }
            }
        }
    }
</script>